<!--数字滑块-->
<template>
  <el-slider
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :clearable="clearable"
  >
  </el-slider>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // import { ElSlider } from 'element-plus'
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-from-item-range',
    inheritAttrs: false,
    components: {
      // ElSlider
    },
    props: {
      ...itemProps, // 基础属性
      modelValue: [String, Number]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      return {
        ...itemController(props, context.emit)
      }
    }
  })
</script>
